export const QueryKey = {
  GetFavoriteListings: 'FavoriteListings',
  GetUserFeeds: 'Feeds',
  GetFeed: 'Feed'
}
